import { API } from "../api";
import { setError } from "./Indicator";
import { IN_BOUND_ORDER_LIST } from "../constants/url.constant";

export const REQUEST_IN_BOUND_SHIPING_LIST = "REQUEST_IN_BOUND_SHIPING_LIST";
export const SET_IN_BOUND_SHIPING_LIST = "SET_IN_BOUND_SHIPING_LIST";

export const setInBoundShipingList = (data) => {
  return {
    type: SET_IN_BOUND_SHIPING_LIST,
    payload: data
  };
};

export const inBoundShipingList = ({ limit, page }) => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_IN_BOUND_SHIPING_LIST });
    try {
      const res = await API.get(`${IN_BOUND_ORDER_LIST}`, {
        params: {
          limit: limit,
          page: page
        }
      });

      return dispatch(setInBoundShipingList(res));
    } catch (error) {
      console.log(error);
      dispatch(setError("Somehing went wrong!"));
    }
  };
};

const initialState = {
  isLoading: false,
  loaded: false,
  columns: [],
  data: [],
  totalRows: {}
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case REQUEST_IN_BOUND_SHIPING_LIST:
      return {
        ...state,
        isLoading: true,
        loaded: false
      };
    case SET_IN_BOUND_SHIPING_LIST:
      return {
        ...state,
        isLoading: false,
        loaded: true,
        columns: payload.columns,
        rows: payload.rows,
        totalRows: payload.count
      };
    default:
      return state;
  }
}
